import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '[foundation-type-2]',
    templateUrl: './foundation-type-2.component.html',
    styleUrl: './foundation-type-2.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FoundationType2Component {
}
